export const filesStatusList = {};
export const fileDeleted = {};
export const FOLDER_TYPE = {type: ''};
export const counterOfFiles = {numberOfFiles: 0, counter: 0, counterFail: 0};
export enum ERROR_UPLOAD {
    TYPE='File type not recognized',
    SIZE='File too big',
    VERIFICATION='Verification process failed',
    UPLOAD='Upload process failed',
    STORAGE='File over the storage size',
    EXIST ='File already exists'
}

export enum IMAGE_STATUS {
    DONE = 'done',
    VERIFY_FAILED= 'verifyFailed',
    FAILED = 'failed',
    CANCEL = 'cancel',
    SUCCESS = 'success',
    UPLOADING = 'uploading'
}
export const PROJECT_ID = {projectId: -1};
